<div class="dialog-content">
  <div *ngIf="isContactFormSent" class="left-section-success">
    <img style="margin-bottom: 40px" src="/assets/icons/check_circle.svg" />
    <p class="fs-34">You have successfully sent a meeting request!</p>
    <button
      *ngIf="!data.isTrialEnded"
      class="mt-25 w-87 h-56 bck-color-blue mt-16 cp"
      mat-raised-button
      type="submit"
      (click)="onClose()"
    >
      Close
    </button>
  </div>

  <div *ngIf="!isContactFormSent" class="left-section">
    <div *ngIf="!data.isTrialEnded">
      <p class="trial-title">Trial expires in {{data?.numberOfDaysLeftForTrial}} days</p>
    </div>
    <div *ngIf="data.isTrialEnded">
      <p class="trial-title red">Your trial has ended</p>
    </div>
    <div>
      <p class="fs-16 mt-32">Do you want us to contact you?</p>
    </div>

    <div style="width: 100%">
      <form class="mt-20" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" required pattern="[0-9\s\/\-\+]*"/>
          <mat-error *ngIf="contactForm.controls['phone'].invalid"
            ></mat-error
          >
        </mat-form-field>

        <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="mt-20">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required />
          <mat-error *ngIf="contactForm.controls['email'].invalid"
            ></mat-error
          >
        </mat-form-field>

        <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="mt-20">
          <mat-label>Your message</mat-label>
          <textarea matInput formControlName="message"></textarea>
        </mat-form-field>

        <button
          class="mt-25 w-100 h-56 bck-color-blue"
          style="text-align: center"
          mat-raised-button
          type="submit"
          [disabled]="contactForm.invalid"
          [ngClass]="{ 'bck-color-grey': isLoading }"
        >
          <span *ngIf="!isLoading">Submit</span>
          <div class="spinner">
            <div>
              <mat-spinner
                *ngIf="isLoading"
                diameter="20"
                color="warn"
              ></mat-spinner>
            </div>
          </div>
        </button>
      </form>
    </div>
    <div style="margin-top: 30px">
      <div class="fs-16">Contact us</div>
      <div class="fs-12 mt-16">+387 62 345 678</div>
      <div class="fs-12 mt-12">support@companyinclouds.com</div>
    </div>
  </div>
  <div class="right-section">
    <mat-icon
      (click)="onClose()"
      *ngIf="!data.isTrialEnded"
      class="close-icon cp"
      >close</mat-icon
    >
    <div>
      <img src="/assets/logo 3.svg" />
    </div>
    <div>
      <img src="/assets/icons/printer.svg" />
    </div>
  </div>
</div>
